import { render } from "./GroupAction.vue?vue&type=template&id=3cc0f8c5"
import script from "./GroupAction.vue?vue&type=script&lang=js"
export * from "./GroupAction.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__